import { render } from "./TopSellers.vue?vue&type=template&id=15c0660b"
import script from "./TopSellers.vue?vue&type=script&lang=js"
export * from "./TopSellers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__